// directive to autosize the height of a textarea element to expand to fit its contents.
angular.module('components.autosize', [])
    .directive('autosize', function () {
        return function (scope, elem, attrs) {
            var resize = function () {
                elem.height(10);
                elem.height(elem[0].scrollHeight + parseFloat(elem.css("borderTopWidth")) + parseFloat(elem.css("borderBottomWidth")));
            };

            elem.bind('keyup', resize);
            if (attrs.ngModel) {
                scope.$watch(attrs.ngModel, function (newValue, oldValue) {
                    if (newValue === oldValue) {
                        resize();
                    }
                });
            }
        };
    });